export default __webpack_public_path__ + "images/RO.82b8021.png";